import { Component } from 'react';
import { createRecordingDialogEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { getActiveSession } from '../../functions';
import LocalRecordingManager from './LocalRecordingManager';
// CUSTOM
// @ts-ignore
import { stopRecordingAPI } from '../../../customise/custom/toolbar/recording-function';
// @ts-ignore
import { hideApiLoader, setRecording, showApiLoader, showToastPopup, stopRecording } from '../../../customise/redux/tool-webjam/actions';
// @ts-ignore
import { socketEmit } from '../../../../../socket';
// @ts-ignore
import { getStore } from '../../../customise/Utils';
// @ts-ignore
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../../../customise/constant';
// @ts-ignore
import { getRecordingStreamingType, sendRecordingEmailApi } from '../../../customise/welcome-dashboard/Request.d';
// @ts-ignore
import { setDefaultRecordingType, setDisableRecIcon, setRecordingModalAction, setRecordingModalCount } from "../../../customise/redux/tool-webjam-v2/actions";
// @ts-ignore
import { CURRENT_ROOM_NAME } from '../../../webjam/constant';
/**
 * Abstract React Component for getting confirmation to stop a file recording
 * session in progress.
 *
 * @augments Component
 */
export default class AbstractStopRecordingDialog extends Component {
    /**
     * Initializes a new {@code AbstrStopRecordingDialog} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        // Bind event handler so it is only bound once for every instance.
        this._onSubmit = this._onSubmit.bind(this);
        this._toggleScreenshotCapture = this._toggleScreenshotCapture.bind(this);
    }
    /**
     * Stops the recording session.
     *
     * @private
     * @returns {boolean} - True (to note that the modal should be closed).
     */
    // CUSTOM
    // _onSubmit() {
    async _onSubmit() {
        // END
        sendAnalytics(createRecordingDialogEvent('stop', 'confirm.button'));
        // CUSTOM
        // if (this.props._localRecording) {
        //     this.props.dispatch(stopLocalVideoRecording());
        //     if (this.props.localRecordingVideoStop) {
        //         this.props.dispatch(setVideoMuted(true));
        //     }
        // } else {
        // const { _fileRecordingSession } = this.props;
        const { _fileRecordingSession, dispatch } = this.props;
        dispatch(setRecording({
            recordingStarted: 2 // set flag for current user which is started/stopped the recording
        }));
        let isJibriRecording = true; // check if recording is Started with jibri based on avstack
        const { authOrganization } = getStore(FEATURE_CUSTOM_REDUX_V2);
        let recordingTypeRes = await getRecordingStreamingType('?organization_id=' + authOrganization?._id);
        if (recordingTypeRes.data.status) {
            dispatch(setDefaultRecordingType(recordingTypeRes.data.data.recording_type));
            isJibriRecording = recordingTypeRes.data.data.recording_type == "JIBRI";
        }
        if (isJibriRecording == false) {
            stopRecordingAPI();
        }
        const { recIpAddress, recTimeStamp, stemRecording, roomorIpAddress } = getStore(FEATURE_CUSTOM_REDUX);
        const { iAmRecorder } = getStore('features/base/config');
        dispatch(setRecordingModalCount(0));
        let obj = {
            recordingip: recIpAddress,
            recordingkey: recTimeStamp
        };
        const { local } = getStore('features/base/participants');
        socketEmit("recording_status", {
            roomName: CURRENT_ROOM_NAME,
            location: window.location.origin,
            timestamp: recTimeStamp,
            status: false,
            // stemStatus: stemRecording,
            jitsiId: local.id,
            iAmRecorder,
            type: 2,
            count: 0
        });
        dispatch(setRecordingModalCount(0));
        // END
        if (_fileRecordingSession) { // @ts-ignore
            this.props._conference.stopRecording(_fileRecordingSession.id);
            this._toggleScreenshotCapture();
            // CUSTOM
            dispatch(showApiLoader());
            setTimeout(function () {
                dispatch(hideApiLoader());
                dispatch(stopRecording({
                    recordingStopped: true
                }));
            }, 5000);
            // END
        }
        // CUSTOM
        // }
        // END
        // CUSTOM
        sendRecordingEmailApi({
            room: CURRENT_ROOM_NAME,
            domain: authOrganization.domain
        });
        dispatch(setRecordingModalCount(0));
        dispatch(showToastPopup({ toastModal: false, modalText: '' }));
        dispatch(setRecordingModalAction('stop'));
        dispatch(setDisableRecIcon(false));
        // END
        return true;
    }
    /**
     * Toggles screenshot capture feature.
     *
     * @returns {void}
     */
    _toggleScreenshotCapture() {
        // To be implemented by subclass.
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code StopRecordingDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _conference: JitsiConference,
 *     _fileRecordingSession: Object
 * }}
 */
export function _mapStateToProps(state) {
    return {
        _conference: state['features/base/conference'].conference,
        _fileRecordingSession: getActiveSession(state, JitsiRecordingConstants.mode.FILE),
        _localRecording: LocalRecordingManager.isRecordingLocally()
    };
}
